export const environment = {
  production: false,
  showDemoButton: true,
  apiBaseUrl: 'https://demo-api.agrigateone.com',
  webSocketUrl: 'wss://demo-api.agrigateone.com/cable',
  authentication: {
    auth0Domain: 'agrigate-dev.eu.auth0.com',
    clientID: 'L3xaVVeBBc2T7CgUKzfKMZmxNxDCMbUL',
    redirectURI: 'https://demo-app.agrigateone.com/login/callback',
    audience: 'https://api-dev.agrigate.com',
    webappUrl: 'https://demo-app.agrigateone.com',
    logoutUrl: 'https://demo-app.agrigateone.com/login',
  },
  pusher: {
    key: '49514a90ca009c54e607',
    options: {
      cluster: 'eu',
      encrypted: true,
    },
  },
  sentry: {
    environment: 'demo',
    dsn: 'https://f992693bf9654428972bd8968d2a13fa@sentry.io/1365705',
    logToSentry: true,
  },
  oneSignal: {
    appId: '575bcdcb-435f-4559-b158-b103947ec8f0',
  },
  freshdesk: {
    domain: 'agrigate',
  },
  gcp: {
    maps: {
      apiKey: 'AIzaSyBiJXMwNwB83uBb5yyaN-P6CamuCA-6ZOE',
    },
  },
};
